import React from 'react';
import { Accordion } from './ui/Accordion';
export function FAQSection() {
  const faqs = [{
    question: '¿Esto es una dieta estricta o voy a tener que prohibirme todo?',
    answer: 'No. El método se basa en ordenar lo que comés, no en eliminarlo. Aprenderás a combinar alimentos para que tu cuerpo los procese mejor sin inflamarte.'
  }, {
    question: '¿Voy a pasar hambre o quedarme con antojos?',
    answer: 'No. El plan incluye desayuno, almuerzo, cena, merienda y picoteos. Está diseñado para mantener tu azúcar en sangre estable, lo que elimina naturalmente los antojos.'
  }, {
    question: '¿Funciona aunque coma sano y aun así me inflame?',
    answer: "Sí. Es el caso más común. Muchos alimentos 'saludables' mal combinados generan fermentación e inflamación. Este método corrige esos errores invisibles."
  }, {
    question: 'No tengo mucho tiempo para cocinar, ¿es para mí?',
    answer: 'Sí. Las recetas son simples, rápidas y sin ingredientes raros. Pensado para mujeres ocupadas.'
  }, {
    question: '¿Necesito ingredientes raros o caros?',
    answer: 'No. Todo lo encontrás en cualquier supermercado o verdulería de barrio.'
  }, {
    question: '¿Cuándo voy a empezar a notar cambios?',
    answer: 'Muchas mujeres notan mejoría en la digestión y reducción de hinchazón en la primera semana.'
  }, {
    question: '¿Sirve si tengo más de 40?',
    answer: 'Sí, y especialmente para vos. A partir de los 35-40 el metabolismo cambia y este método trabaja a favor de tu biología actual.'
  }, {
    question: '¿Es solo un recetario o también me enseña qué hacer paso a paso?',
    answer: 'Es un plan completo. Tenés el calendario día por día, la guía de combinaciones y la explicación del por qué.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: '100% digital. Acceso inmediato por email tras la compra. Podés verlo en tu celular, tablet o computadora.'
  }, {
    question: '¿Y si lo compro y no es para mí?',
    answer: 'Tenés 7 días de garantía total. Si no te sirve, te devolvemos todo tu dinero sin preguntas.'
  }];
  return <section className="py-10 bg-cream" data-id="element-148">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="text-center mb-8" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-4" data-id="element-151">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-sage/80" data-id="element-152">
            Todo lo que necesitás saber antes de empezar tu transformación.
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-153">
          <Accordion items={faqs} data-id="element-154" />
        </div>
      </div>
    </section>;
}